import React, { useState, useEffect } from 'react';
import Input from '@hubins/components/Input';
import Button, { ButtonWrap } from '@hubins/components/Button';
import Modal from '@hubins/components/Modal';
import ChooseSecurities from '@hubins/components/ChooseSecurities';
import __ from 'localisation';

type Props = {
  callback: (security: object) => void;
  value?: any;
  controlled?: boolean;
}

const ChooseSecuritiesInput = ({ callback, value, controlled = false }: Props) => {

  const [open, setOpen] = useState<boolean>(false);
  const [security, setSecurity] = useState<any>(value || null);

  useEffect(() => {
    callback(security);
    if (security) {
      setOpen(false);
    }
  }, [security])

  return (
    <>
      <Modal
        callback={setOpen}
        open={open}
        closeButton
      >
        <ChooseSecurities callback={setSecurity} />
      </Modal>
      <div className='flex-horizontal-center'>
        <div className="wide">
          <Input
            label={__('security')}
            value={controlled ? value?.name || '' : security?.name || ''}
            disabled={true}
            controlled
          />
        </div>
        <div className="s-left-m s-right-m wide">
          <ButtonWrap>
            <Button
              onClick={() => setOpen(true)}
              icon="Common File Stack by Streamlinehq"
            >
              {__('choose_security')}
            </Button>
            {security && (
              <Button
                className='danger'
                icon="Bin by Streamlinehq"
                iconColor='white'
                onClick={() => setSecurity(null)}
              >
                {__('delete')}
              </Button>
            )}
          </ButtonWrap>
        </div>
      </div>
    </>
  )
};

export default ChooseSecuritiesInput;